// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2xju0","dragIcon":"SortableItem_dragIcon__kxnxw","disabled":"SortableItem_disabled__1VYHU"};